var React = require('react');

function Briefcase (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M320 288h192v144c0 25.6-22.4 48-48 48H48c-25.6 0-48-22.4-48-48V288h192v48a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464 128h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128z","className":"fa-primary","key":2})]);
}

Briefcase.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Briefcase;

Briefcase.default = Briefcase;
